import { LitElement, html, css } from "lit";
import "@matter/matter-link/dist/matter-link";

class MatterFooter extends LitElement {
  static get styles() {
    return css``;
  }

  static get properties() {
    return {
      stylesheetVersion: { type: String },
      data: { type: String },
      dominio: { type: String },
      ocultarSecciones: { type: String },
      ocultarSeccionSocial: { type: String },
      imageFooterRight: { type: String },
      imageFooterRightAlt: { type: String },
      footerTopBanners: { type: Array },
      urlFooterRight: { type: String },
      _response: { type: Object },
    };
  }

  constructor() {
    super();
    this.stylesheetVersion = 'latest';
    this.data = "";
    this.dominio = "";
    this.ocultarSecciones = "false";
    this.ocultarSeccionSocial = "false";
    this.imageFooterRight = "";
    this.imageFooterRightAlt = "";
    this.footerTopBanners = [];
    this.urlFooterRight = "";
    this._response = {
      columns: [],
      links: [],
      social: [],
      logos: [],
    };

    const href = 'https://cdn.juntadeandalucia.es/components/sass/' + this.stylesheetVersion + '/css/fonts.css';
    if (!document.querySelector(`link[href="${href}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
    }
  }

  connectedCallback() {
    super.connectedCallback();
    const stylesheets = [
      'https://cdn.juntadeandalucia.es/components/sass/' + this.stylesheetVersion + '/css/custom-jda-bootstrap.css',
      'https://cdn.juntadeandalucia.es/components/sass/' + this.stylesheetVersion + '/css/all.css',
    ];
    stylesheets.forEach(href => {
      const linkElement = document.createElement('link');
      linkElement.rel = 'stylesheet';
      linkElement.href = href;
      this.shadowRoot.appendChild(linkElement);
    });
    // Si viene data, cargar remoto
    if (this.data) this.updatedResponse();
  }

  async _loadItemsFromUrl() {
    console.log("DATA:", this.data);
    if(this.data == null) {
      return;
    }

    try {
      const res = await fetch(this.data);
      if (!res.ok) {
        console.error('Error al cargar datos:', res.status);
        return;
      }
      const json = await res.json();
      this._response = json;
      // Si el JSON trae footerTopBanners y el componente no tiene, los usamos
      if (json != null && json.footerTopBanners && (!this.footerTopBanners || this.footerTopBanners.length === 0)) {
        this.footerTopBanners = json.footerTopBanners;
      }
    } catch (e) {
      console.error('Fetch error:', e);
    }
  }

  render() {
    return html`
      <footer class="site-footer">
        <div class="site-footer__top bg-secondary" style="display: none;">
          <div class="container">
            <div class="row">
              ${this.getAttribute("ocultarSecciones") === "false"
        ? html`
                    ${this._response.columns.map(
          (column, index) => html`
                        <div class="col-12 col-sm-6 col-lg-3">
                          ${column.columna.map(
            (column2) => html`
                              <section class="mb-5">
                                <h2>${column2.title}</h2>
                                <nav>
                                  <ul>
                                    ${column2.array.map(
              (link) => html`
                                        <li>
                                          <matter-link 
                                            stylesheetversion="latest" 
                                            textcontent="${link.title}" 
                                            linkurl="${link.href.substr(0, 4) === "http" || !this.getAttribute('dominio') ? link.href : this.dominio + link.href}" 
                                            textcolor="white"
                                          ></matter-link>
                                        </li>
                                      `
            )}
                                  </ul>
                                </nav>
                              </section>
                            `
          )}
                          ${this.getAttribute("ocultarSeccionSocial") === "false"
              ? html`
                                ${this._response.columns.length - 1 === index
                  ? html`
                                      <div class="column widthColumns">
                                        ${(this.footerTopBanners && this.footerTopBanners.length > 0) ? html`
                                          <div class="footer-top-banners mb-4 row  px-2">
                                            ${this.footerTopBanners.map(banner => html`
                                              <div class="${banner.classes}">
                                                ${banner.url && banner.url !== "" ? html`
                                                  <a href="${banner.url}">
                                                    <img src="${banner.image}" alt="${banner.alt}" class="img-fluid" />
                                                  </a>
                                                ` : html`
                                                  <img src="${banner.image}" alt="${banner.alt}" class="img-fluid" />
                                                `}
                                              </div>
                                            `)}
                                          </div>
                                        ` : html``}
                                        ${this._response.social.map((social) => html`
                                            <div>
                                              <h2>
                                                ${social.title}
                                              </h2>
                                              <ul class="list-inline">
                                                ${social.array.map((socialAux) => html`
                                                    <li class="list-inline-item">
                                                      ${socialAux.image !== "" && socialAux.icon === ""
                      ? html` 
                                                            <a href="${socialAux.href.substr(0, 4) === "http" || !this.getAttribute('dominio') ? socialAux.href : this.dominio + socialAux.href}">
                                                              <img src="${socialAux.image}" alt="${socialAux.alt}" title="${socialAux.title}" />
                                                            </a>
                                                          `
                      : html``}
                                                      ${socialAux.image === "" && socialAux.icon !== ""
                      ? html`
                                                            <matter-link 
                                                              stylesheetversion="latest" 
                                                              textcontent="" 
                                                              linkurl="${socialAux.href.substr(0, 4) === "http" || !this.getAttribute('dominio') ? socialAux.href : this.dominio + socialAux.href}" 
                                                              textcolor="white" 
                                                              iconcolor="white" 
                                                              linktarget="" 
                                                              iconclass="fa-brands fa-${socialAux.icon} fa-lg" 
                                                              ariaLabel="${socialAux.name}"
                                                            ></matter-link>
                                                          `
                      : html``}
                                                    </li>
                                                  `
                  )}
                                              </ul>
                                            </div>
                                          `
                  )}
                                      </div>
                                    `
                  : html``}
                              `
              : html``}
                        </div>
                      `
        )}
                  `
        : html``}
            </div>
          </div>
        </div>

        <div class="site-footer__bottom">
          <div class="container" style="max-width: 90% !important";>
            <section class="d-flex flex-column flex-lg-row align-items-center">
              <div class="d-flex align-items-center mb-5 mb-lg-0">
                ${this._response.logos.map(
          (logos) => html`${(logos.href === undefined || logos.href === "") ?
            html`
                      <div class="logo-footer me-4">
                        <img src="${logos.image}" alt="${logos.alt}" class="footer-logo"/>
                      </div>
                    `: html`
                      <div class="logo-footer me-4">
                        <a class="logosFooter" href="${logos.href.substr(0, 4) === "http" || !this.getAttribute('dominio') ? logos.href : this.dominio + logos.href}">
                          <img src="${logos.image}" alt="${logos.alt}" class="footer-logo" />
                        </a>
                      </div>
                    `}`
        )}
              </div>
              <div class="enlace-footer ms-lg-auto">
                <div>
                  <ul class="nav flex-column text-center flex-md-row">
                    ${this._response.links.map(
          (link) => html`
                        <li class="nav-item">
                          <div class="nav-link">
                            <matter-link 
                              stylesheetversion="latest" 
                              textcontent="${link.title}" 
                              linkurl="${link.href.substr(0, 4) === "http" || !this.getAttribute('dominio') ? link.href : this.dominio + link.href}" 
                              textcolor="gray"
                            ></matter-link>
                          </div>
                        </li>
                      `
        )}
                  </ul>
                </div>                  
              </div>
              
              ${this.imageFooterRight
        ? html`
                  <div class="d-flex align-items-center mb-5 mb-lg-0 ms-lg-auto">
                    <div>
                      <div class="logo-footer me-0">
                        <a href="${this.urlFooterRight}">
                          <img
                            alt="${this.imageFooterRightAlt}"
                            src="${this.imageFooterRight}"
                            width="120"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                `
        : html``}
            </section>
          </div>
        </div>
      </footer>
    `;
  }

  updated(changedProperties) {
    changedProperties.forEach((_, propName) => {
      if (["data"].includes(propName)) {
        this.updatedResponse();
      }
      if (["ocultarSecciones"].includes(propName)) {
        this.setocultarSecciones(this.ocultarSecciones);
      }

      if (["ocultarSeccionSocial"].includes(propName)) {
        this.setocultarSeccionSocial(this.ocultarSeccionSocial);
      }

      if (["dominio"].includes(propName)) {
        this.setDominio(this.dominio);
      }
    });
  }

  updatedResponse() {
    if (!this.data) {
      return;
    }

    try {
      this._response = JSON.parse(this.data);
    } catch (e) {
      this._loadItemsFromUrl();
    }
  }

  async loadTreeMapData() {
    await fetch(this.data)
      .then(response => response.json())
      .then(data => {
        this._response = data;
        if (data.footerTopBanners && (!this.footerTopBanners || this.footerTopBanners.length === 0)) {
          this.footerTopBanners = data.footerTopBanners;
        }
      })
      .catch(error => "");
  }

  getocultarSecciones() {
    return this.getAttribute("ocultarSecciones");
  }

  setocultarSecciones(newValue) {
    this.setAttribute("ocultarSecciones", newValue);
  }

  getocultarSeccionSocial() {
    return this.getAttribute("ocultarSeccionSocial");
  }

  setocultarSeccionSocial(newValue) {
    this.setAttribute("ocultarSeccionSocial", newValue);
  }

  getDominio() {
    return this.getAttribute("dominio");
  }

  setDominio(newValue) {
    this.setAttribute("dominio", newValue);
  }
}

if (!window.customElements.get("matter-footer")) {
  window.customElements.define("matter-footer", MatterFooter);
}
